import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  content: {
    flexGrow: 1,
    width: '100%',
    paddingTop: '70px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  image: {
    width: '48px',
    height: '48px'
  },
  paper: {
    width: '445px',
    padding: '35px'
  },
  paperTitle: {
    textAlign: 'center',
    marginBottom: '30px',
    fontSize: '1.75rem'
  },
  buttonRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  dialogTextContent: {
    padding: '15px'
  }
}))
